import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

const getUsuariosProex = () => {
  const USUARIOS_PROEX_URL = API_URL + '/usuarios-proex'
  let config = {
    method: 'get',
    url: USUARIOS_PROEX_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

export default {
  getUsuariosProex
}



// WEBPACK FOOTER //
// ./src/utils/usuariosProex.js